import Channel from './Channel';

export default class ChannelForm {
  constructor(
    bio = null,
    categories = [],
    city = null,
    channel_name = '',
    channel_image = null,
    name = '',
    picture = null,
    specialties = [],
    sports = [],
    tags = [],
    user_id = null,
    username = null,
    video = '',
    primaryStatus = null,
    statuses = [],
    trainer_relationship = null,
    website = null,
  ) {
    this.bio = bio;
    this.categories = categories;
    this.city = city;
    this.channel_name = channel_name;
    this.channel_image = channel_image;
    this.name = name;
    this.picture = picture;
    this.specialties = specialties;
    this.sports = sports;
    this.tags = tags;
    this.user_id = user_id;
    this.username = username;
    this.video = video;
    this.primaryStatus = primaryStatus;
    this.statuses = statuses;
    this.trainer_relationship = trainer_relationship;
    this.website = website;
  }

  formatforDB() {
    const data = {
      bio: this.bio,
      categories: this.categories.map( item => item.toLowerCase().replace(/\s+/g, '-') ),
      city: (this.city && this.city.id) ? this.city.id : null,
      channel_name: this.channel_name,
      channel_image: this.channel_image ? this.channel_image.id : null,
      name: this.name,
      picture: this.picture ? this.picture.url : null,
      specialties: this.specialties,
      sports: this.sports,
      tags: this.tags.map(item => item.value),
      user_id: this.user_id,
      username: this.username,
      video: this.video ? this.video.id : null,
      website: this.website,
    }

    return new Channel(
      data.bio,
      data.categories,
      data.city,
      data.channel_name,
      data.channel_image,
      data.name,
      data.picture,
      data.specialties,
      data.sports,
      data.tags,
      data.user_id,
      data.username,
      data.video,
      data.website,
    );
  }

  formatForForm(obj) {
    const exer = new Channel();
    if(obj) {
      for (const key in exer) {
        if (obj.hasOwnProperty(key)) {
          exer[key] = obj[key];
        }
      }
    }

    this.bio = exer.bio;
    this.categories = exer.categories;
    this.city = exer.city;
    this.channel_name = exer.channel_name ? exer.channel_name : '';
    this.channel_image = exer.channel_image;
    this.name = exer.name;
    this.picture = {url: exer.picture};
    this.specialties = exer.specialties;
    this.sports = exer.sports;
    this.tags = exer.tags.map(item => ({label: item, value: item}));
    this.user_id = exer.user_id;
    this.username = exer.username;
    this.video = exer.video;
    this.trainer_relationship = exer.trainer_relationship;
    this.website = exer.website;

    this.checkValidity();
  }

  checkValidity() {
    let primaryStatus = 'Valid';
    let statusList = {};
    const channelnameText = 'Channel Name';
    const cityText = 'Selected City';
    const categoriesText = 'Selected Categories';
    const tagsText = 'Added Tags';
    const bio1Text = 'Answered the question "Tell us about you."';
    const pictureText = 'Uploaded a profile picture';
    const videoText = 'Uploaded a bio video';
    const imageText = 'Uploaded a thumbnail picture to overlay the bio video';
    const nameText = 'Trainer Name';

    if(this.name !== '') {
      statusList.name = {value: true, text: nameText};
    } else {
      primaryStatus = 'Invalid';
      statusList.name = {value: false, text: nameText};
    }

    if(this.channel_name !== '') {
      statusList.channel_name = {value: true, text: channelnameText};
    } else {
      primaryStatus = 'Invalid';
      statusList.channel_name = {value: false, text: channelnameText};
    }

    if(this.channel_image && this.channel_image.url !== '' && this.channel_image.url !== null) {
      statusList.channel_image = {value: true, text: imageText};
    } else {
      primaryStatus = 'Invalid';
      statusList.channel_image = {value: false, text: imageText};
    }

    if(this.picture && this.picture.url !== '' && this.picture.url !== null) {
      statusList.picture = {value: true, text: pictureText};
    } else {
      primaryStatus = 'Invalid';
      statusList.picture = {value: false, text: pictureText};
    }

    if(this.video && this.video.url !== '' && this.video.url !== null) {
      statusList.video = {value: true, text: videoText};
    } else {
      primaryStatus = 'Invalid';
      statusList.video = {value: false, text: videoText};
    }

    if (this.trainer_relationship === "trainer") {
      if(this.city !== null) {
        statusList.city = {value: true, text: cityText};
      } else {
        primaryStatus = 'Invalid';
        statusList.city = {value: false, text: cityText};
      }

      if(this.categories.length > 0) {
        statusList.categories = {value: true, text: categoriesText};
      } else {
        primaryStatus = 'Invalid';
        statusList.categories = {value: false, text: categoriesText};
      }

      if(this.tags.length > 0) {
        statusList.tags = {value: true, text: tagsText};
      } else {
        primaryStatus = 'Invalid';
        statusList.tags = {value: false, text: tagsText};
      }

      if(this.bio.bio1 && this.bio.bio1 !== '') {
        statusList.bio1 = {value: true, text: bio1Text};
      } else {
        primaryStatus = 'Invalid';
        statusList.bio1 = {value: false, text: bio1Text};
      }
    }
    
    this.primaryStatus = primaryStatus;
    this.statuses = statusList;
  }
}
